import { Component, OnInit, HostListener } from '@angular/core';
import { MultistepsService } from '@app/modules/applicant/base';
import { SessionService, StepsIdEnum, LookupsService, CompaniesEnum,
  LimitlessUiService, ConstantsService, RequestTypesEnum } from '@app/base/core';
import { FormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { CanComponentDeactivate } from '@app/base/shared';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { isNullOrUndefined } from 'util';

declare var swal: any;
require('sweetalert');

@Component({
  selector: 'residential-premise',
  templateUrl: './residential.premise.component.html',
})
export class ResidentialPremiseComponent implements OnInit, CanComponentDeactivate {
  form: FormGroup;
  stepsIdEnum: typeof StepsIdEnum = StepsIdEnum;
  companiesEnum: typeof CompaniesEnum = CompaniesEnum;
  requestTypesEnum: typeof RequestTypesEnum = RequestTypesEnum;
  selectedIDsforResidential: any[] = [];
  deliveryPressOthersResidential = false;
  applianceCountR = true;
  public btuLoadVal = 'BTU Load Value (Optional)';
  typeform: FormGroup;

  @HostListener('window:beforeunload', ['$event']) onBeforeUnload(event) {
      event.preventDefault();
      // Specially for chrome...
      event.returnValue = this.constantsSvc.changes;
    }

  constructor(public wizardSvc: MultistepsService, private constantsSvc: ConstantsService,
    public sessionSvc: SessionService, public lookupSvc: LookupsService, public limitlessSvc: LimitlessUiService) {

  }
   ngOnInit() {
    this.form = this.wizardSvc.getStepById(this.stepsIdEnum.PREMISE).form;
    this.typeform = this.wizardSvc.getStepById(this.stepsIdEnum.TYPE).form;

     // To Set the Status Construction Field value based on the type question response.
     if (this.typeform.controls['question5'].value === this.constantsSvc.Yes) {
      this.form.controls['residentialStatusofConstruction'].setValidators(Validators.required);
      this.form.updateValueAndValidity();
    } else {
      this.form.controls['residentialStatusofConstruction'].clearValidators();
      this.form.updateValueAndValidity();
    }
    
    //To disable/enable "Marketer of Choice" field based on form load
    if (this.form.controls['marketerChosen'].value === this.constantsSvc.Yes) {
      this.form.controls['marketerChoice'].enable();
    }
    else if (this.form.controls['marketerChosen'].value === this.constantsSvc.No) {
      this.form.controls['marketerChoice'].disable();
    }
    else {
      this.form.controls['marketerChoice'].disable();
    }
    

    if (isNullOrUndefined(this.form.controls['residentialDeliveryPressure'].value)) {
      this.form.patchValue({
        residentialDeliveryPressure: this.lookupSvc.defaultResidentialPressure.lookupValues[0],
      });
    }

    if (this.sessionSvc.paramLdc === this.companiesEnum.FL) {
      this.form.controls['residentialPropertyOwner'].setValidators(Validators.required);
    }
    if (this.sessionSvc.paramLdc === this.companiesEnum.GA && this.wizardSvc.paramRequestType.toUpperCase() === this.requestTypesEnum.Residential) {
      this.form.controls['marketerChosen'].setValidators(Validators.required);
    }

    if ((this.form.controls['residentialDeliveryPressure'].value &&
      this.form.controls['residentialDeliveryPressure'].value['itemName'].toUpperCase() === this.constantsSvc.other) ||
      this.form.controls['residentialDeliveryPressureOthers'].value !== ''
      && !isNullOrUndefined(this.form.controls['residentialDeliveryPressureOthers'].value)) {
      this.deliveryPressOthersResidential = true;
    } else {
      this.deliveryPressOthersResidential = false;
      this.form.controls['residentialDeliveryPressureOthers'].clearValidators();
      this.form.controls['residentialDeliveryPressureOthers'].updateValueAndValidity();
    }

    const formArray = <FormArray>this.form.controls['appliancesforResidential'];
    if (formArray.length > 49) {
      this.applianceCountR = false;
    }

  }

  canDeactivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot, nextState:
    RouterStateSnapshot) { return this.wizardSvc.canDeactivateStep(route, state, nextState); }
// To Add Appliances for Residential Premise
  addAppliancesforResidential() {
    const formArray = <FormArray>this.form.controls['appliancesforResidential'];
    formArray.push(new FormGroup({
      defaultAppliance: new FormControl(null, [Validators.required]),
      defaultApplianceOther: new FormControl(null),
      quantity: new FormControl('', [Validators.required, Validators.pattern(this.constantsSvc.numericPattern)]),
      defaultValue: new FormControl('', [Validators.pattern(this.constantsSvc.numericPatternwithZero)]),
      existingLoad: new FormControl(false)
    })
    );
    if (formArray.length > 49) {
      this.applianceCountR = false;
    }
  }
  // Delete Appliances of Residential Premise
  deleteApplianceforResidential() {
    const control = <FormArray>this.form.controls['appliancesforResidential'];
    if (this.selectedIDsforResidential.length === 0) { swal(this.constantsSvc.premiseSwal1, this.constantsSvc.premiseSwal2); }
    this.selectedIDsforResidential.sort((a, b) => b - a);
    this.selectedIDsforResidential.forEach(function (index) {
      control.removeAt(index);
    });
    if (control.length < 50) {
      this.applianceCountR = true;
    }
    this.selectedIDsforResidential = [];
  }
// selected ids for deletion
  selectIDforResidential(id, event: any) {
    if (event.target.checked) {
      this.selectedIDsforResidential.push(id);
    } else if (!event.target.checked) {
      const index = this.selectedIDsforResidential.indexOf(id);
      this.selectedIDsforResidential.splice(index, 1);
    }
  }

// Selection of type of delivery pressure required
  onItemSelect(eve: any) {

    if (isNullOrUndefined(eve)) {
      this.form.controls['residentialDeliveryPressureOthers'].reset('');
      this.form.controls['residentialDeliveryPressureOthers'].clearValidators();
      this.form.updateValueAndValidity();
      this.deliveryPressOthersResidential = false;
    } else if (eve.itemName.toUpperCase() === this.constantsSvc.other) {
      this.deliveryPressOthersResidential = true;
      this.form.controls['residentialDeliveryPressureOthers'].setValidators([Validators.required]);
    } else {
      this.form.controls['residentialDeliveryPressureOthers'].reset('');
      this.form.controls['residentialDeliveryPressureOthers'].clearValidators();
      this.form.controls['residentialDeliveryPressureOthers'].updateValueAndValidity();
      this.deliveryPressOthersResidential = false;
      this.form.updateValueAndValidity();
    }
    this.form.updateValueAndValidity();
  }

  // getcontrolvalue is for getting the "Have you chosen a Marketer" selected value
    getControlValue(controlName: string) { return this.form.get(controlName).value; }

  //Method for "Have you chosen a Marketer" change
  onMarketerChosenSelected(eve: any) {
    if (isNullOrUndefined(eve)) {
      this.form.controls['marketerChoice'].disable();
      this.form.controls['marketerChoice'].reset(null);
    }
    else if (eve === this.constantsSvc.Yes) {
        this.form.controls['marketerChoice'].enable();
        this.lookupSvc.MarketerOfChoice = this.lookupSvc.MarketerOfChoice.filter(x => x.itemName.toUpperCase() !== 'UNDECIDED');
        this.form.controls['marketerChoice'].reset(null);
      }
    else if(eve === this.constantsSvc.No) {
      this.form.patchValue({
        marketerChoice : this.lookupSvc.MarketerOfChoiceUndecided.find(x => x.itemName.toUpperCase() === 'UNDECIDED')
       });
       this.form.controls['marketerChoice'].disable();
       this.lookupSvc.MarketerOfChoice = this.lookupSvc.MarketerOfChoiceUndecided;
    }
    else {
      this.form.controls['marketerChoice'].disable();
      this.form.controls['marketerChoice'].reset(null);
    }
  }

// selection of Appliance and getting BTU Load value
  onApplianceSelected(item: any, appArr: FormGroup) {
    appArr.controls['defaultValue'].reset(null);
    appArr.controls['defaultValue'].clearValidators();
    appArr.controls['defaultApplianceOther'].reset(null);
    appArr.controls['defaultApplianceOther'].clearValidators();
    this.btuLoadVal = this.constantsSvc.btuLoadOption;
    if (item['itemName'].toUpperCase() === this.constantsSvc.other) {
      this.btuLoadVal = this.constantsSvc.btuLoadOption;
      appArr.controls['defaultApplianceOther'].setValidators(Validators.required);
      appArr.controls['defaultValue'].setValidators(Validators.pattern(this.constantsSvc.numericPatternwithZero));
      appArr.controls['defaultApplianceOther'].updateValueAndValidity({
        onlySelf: true
      });
      appArr.controls['defaultValue'].updateValueAndValidity({
        onlySelf: true
      });
    } else if ((item['itemName'].toUpperCase() === this.constantsSvc.poolHeater) ||
    (item['itemName'].toUpperCase() === this.constantsSvc.standbyGenerator2)) {
      this.btuLoadVal = this.constantsSvc.btuLoadOption;
      appArr.controls['defaultValue'].setValidators(Validators.pattern(this.constantsSvc.numericPatternwithZero));
      appArr.controls['defaultValue'].updateValueAndValidity({
        onlySelf: true
      });
      appArr.controls['defaultApplianceOther'].reset(null);
      appArr.controls['defaultApplianceOther'].clearValidators();
    } else {
      this.btuLoadVal = this.constantsSvc.btuLoad;
      const homeSqFt = this.form.controls['residentialHomeSqFt'].value;
      const requestType = item.usageType.toUpperCase() ==='RESIDENTIAL' ? 'RES':'COMM';
    
      const loadValue = this.lookupSvc.wrLoadArmLkp.filter(load => 
        load.loadTypeCode === item.id && load.resiComm === requestType &&
        ((load.minSqFTG === null || load.minSqFTG <= homeSqFt) &&
        (load.maxSqFTG === null || load.maxSqFTG >= homeSqFt))
        );

    if(loadValue.length > 0)
    {
      appArr.controls['defaultValue'].setValue(loadValue[0]['itemName']);
        }

      appArr.controls['defaultApplianceOther'].reset(null);
      appArr.controls['defaultApplianceOther'].clearValidators();
      appArr.controls['defaultValue'].setValidators([Validators.required, Validators.pattern(this.constantsSvc.numericPatternwithZero)]);
    }
    appArr.updateValueAndValidity();
  }
}
